import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { dashboards } from '@/data/dashboards';
import DebugAuth from '@/components/ui/DebugAuth';

const DashboardsLandingPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Dashboards | SaunaDip Admin</title>
      </Helmet>
      <div className="container mx-auto p-6 space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-3xl font-bold tracking-tight">Dashboards</h1>
            <p className="text-muted-foreground">
              Select a dashboard to view detailed analytics.
            </p>
          </div>
        </div>

        {/* Temporary Debug Component */}
        <DebugAuth />

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {dashboards.map((dashboard) => (
            <Link to={dashboard.path} key={dashboard.name}>
              <Card className="h-full hover:bg-muted/50 transition-colors">
                <CardHeader className="flex flex-row items-center gap-4 space-y-0">
                  <div className="bg-primary/10 p-3 rounded-md">
                    <dashboard.icon className="h-6 w-6 text-primary" />
                  </div>
                  <div>
                    <CardTitle>{dashboard.name}</CardTitle>
                  </div>
                </CardHeader>
                <CardContent>
                  <CardDescription>{dashboard.description}</CardDescription>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
};

export default DashboardsLandingPage; 